import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Button from "@mui/material/Button";
import {Link} from "react-router-dom";
import CaligraphyImage from "../assets/caligraphy_dark.png";
import MerchTeeImage from "../assets/merch/tee.png";
import MerchStickerBlackImage from "../assets/merch/sticker_black.png";
import MerchStickerWhiteImage from "../assets/merch/sticker_white.png";

const muiTheme = createTheme({
    palette: {
        primary: {
            main: "#FF2E28",
        },
        secondary: {
            main: "#FFF",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: "montserratbold",
                    fontSize: '1rem',
                    padding: '10px 28px',
                    borderRadius: '4',
                },
            }
        },
    }
});

const useStyles = theme => ({
    panel: {
        zIndex: '999',
        backgroundColor: '#0D0D0D',
        width: '100%',
        height: '100%',
        minHeight: '100%',
        display: 'flex',
    },
    effectLogo: {
        display: 'flex',
        height: '100%',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: 'url(' + CaligraphyImage + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '183px 356px',
        backgroundPosition: 'calc(0% - 34px) calc(50% + 160px)',

        [theme.breakpoints.up('md')]: {
            backgroundSize: '305px 593px',
            backgroundPosition: 'calc(50% - 390px) 190px',
        },

        [theme.breakpoints.up('lg')]: {
            backgroundPosition: 'calc(50% - 440px) 180px',
        }
    },
    content: {
        width: '100%',
        height: '100%',
        background: '#F4EFEA',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        margin: '80px 32px 200px 32px',

        [theme.breakpoints.up('md')]: {
            width: '862px',
            flexDirection: 'row',
            margin: '120px 32px 160px 32px',
        },

        [theme.breakpoints.up('lg')]: {
            width: '982px',
        }
    },
    textContent: {
        textAlign: 'left',
        padding: '26px 26px 12px 26px',

        [theme.breakpoints.up('md')]: {
            width: '40%',
            padding: '46px 26px 46px 16px',
        },

        [theme.breakpoints.up('lg')]: {
        }
    },
    title: {
        fontFamily: 'Divona',
        fontSize: '2.7em',
        lineHeight: '1.2em',
        color: '#7B3938',
    },
    subtitle: {
        fontFamily: 'montserratbold',
        letterSpacing: '0.1em',
        margin: '12px 0',
        textTransform: 'uppercase',
        color: '#2D2824',
    },
    text: {
        margin: '0 0 20px 0',
        color: '#2D2824',
    },
    btn: {
        textAlign: 'left',
    },
    merchContent: {
        position: 'relative',
        height: '200px',
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',

        [theme.breakpoints.up('md')]: {
            height: '100%',
        }
    },
    merchTee: {
        position: 'absolute',
        top: '0px',
        left: 'calc(50% - 26px)',
        width: '172px',

        [theme.breakpoints.up('md')]: {
            top: 'calc(100% - 335px)',
            left: '100% - 276px',
            width: '276px',
        },

        '& img': {
            width: '100%',
        }
    },
    merchStickerWhite: {
        position: 'absolute',
        top: '88px',
        left: 'calc(50% - 46px)',
        width: '150px',

        [theme.breakpoints.up('md')]: {
            top: 'calc(100% - 190px)',
            left: 'calc(50% - 96px)',
            width: '242px',
        },

        '& img': {
            width: '100%',
        }
    },
    merchStickerBlack: {
        position: 'absolute',
        top: '34px',
        left: 'calc(50% - 146px)',
        width: '150px',

        [theme.breakpoints.up('md')]: {
            top: 'calc(100% - 300px)',
            left: 'calc(50% - 270px)',
            width: '242px',
        },

        '& img': {
            width: '100%',
        }
    },
    merchMobile: {
        display: 'block',

        [theme.breakpoints.up('md')]: {
            display: 'none',
        }
    },
    merchDesktop: {
        display: 'none',

        [theme.breakpoints.up('md')]: {
            display: 'block',
            width: '60%',
        }
    }
});

class MerchPanel extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
    }

    render() {
        const { classes } = this.props;
        let self = this;

        return (
            <ThemeProvider theme={muiTheme}>

            <div className={classes.panel}>
                <div className={classes.effectLogo}>

                <div className={classes.content}>
                    <div className={classes.merchDesktop}>
                    <div className={classes.merchContent}>
                        <div className={classes.merchTee}><img src={MerchTeeImage} /></div>
                        <div className={classes.merchStickerWhite}><img src={MerchStickerWhiteImage} /></div>
                        <div className={classes.merchStickerBlack}><img src={MerchStickerBlackImage} /></div>
                    </div>
                    </div>

                    <div className={classes.textContent}>

                        <div className={classes.title}>Kung Fu Special</div>
                        <div className={classes.subtitle}>Unbeatable value</div>
                        <div className={classes.text}>Start your Kung Fu journey with the Adelaide Wing Chun Academy, developing <strong>self-defence</strong>, <strong>fitness</strong>, <strong>coordination</strong> and <strong>concentration</strong>.  This offer includes 2 days of classes and a training shirt - over $75 value!</div>
                        <div className={classes.btn}><Link to="/offer"><Button variant="contained">Grab for $49.95</Button></Link></div>
                        {/*
                        <div className={classes.title}>Merchandise</div>
                        <div className={classes.subtitle}>We have training shirts and super slick vinyl stickers!</div>
                        <div className={classes.text}>Join up and get your free high quality vinyl sticker with your training book - we have exclusive stickers for our Dragons Club Kids too!</div>
                        <div className={classes.btn}><Link to="/freelesson"><Button variant="contained">Book my free lesson</Button></Link></div>
                        */}
                    </div>

                    <div className={classes.merchMobile}>
                    <div className={classes.merchContent}>
                        <div className={classes.merchTee}><img src={MerchTeeImage} /></div>
                        <div className={classes.merchStickerWhite}><img src={MerchStickerWhiteImage} /></div>
                        <div className={classes.merchStickerBlack}><img src={MerchStickerBlackImage} /></div>
                    </div>
                    </div>
                </div>

                </div>
            </div>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(MerchPanel)